import type { ReactNode } from 'react';

import {
  TOP_NAV_DATA_GA,
  TOP_NAV_DATA_TEST,
} from '@/app/components/layouts/top-navigation/tracking';
import { Link } from '@/app/components/navigation/link';
import type { TopNavigationVariantType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';

interface TopNavigationLogoProps {
  logo: ReactNode;
  variant?: TopNavigationVariantType;
  onMouseEnter?: () => void;
}

export const TopNavigationLogo = ({
  logo,
  variant = 'filled',
  onMouseEnter,
}: TopNavigationLogoProps) => (
  <Link
    href="/"
    {...createDataAttributes({
      test: TOP_NAV_DATA_TEST.logo,
    })}
    {...createDataGA({
      click: true,
      eventName: TOP_NAV_DATA_GA.topNavigation,
      text: TOP_NAV_DATA_GA.logo,
      url: '/',
    })}
    className={cn('aspect-8-3 flex items-center outline-none', {
      'text-red-500': variant === 'filled',
      'text-white': variant === 'transparent',
    })}
    onMouseEnter={onMouseEnter}
  >
    {logo}
  </Link>
);
